module.exports = __webpack_public_path__ + "static/media/loading.cc37b767.svg";